module.exports = __webpack_public_path__ + "static/img/people-in-couch-1024248.3206f6f5.jpg";